import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../Common/Layout";
import axios from "axios";
import { Toast } from "primereact/toast";
import { formatPhoneNumberDash, formatDateOfBirth } from "../utils/dateFormat";
interface ClientData {
  id: string;
  firstName: string;
  lastName: string;
  eMail: string;
  phone: string;
  address: string;
  city: string;
  state: string;
  zipCode: string;
  dateOfBirth: string;
  policyCount: number;
  lastActivity: string;
  status: "Active" | "Inactive" | "Suspended";
  totalPremium: string;
  vinNumber?: string;
  latestQuote?: {
    effectiveDate?: string;
    number?: string;
    isQuote?: boolean;
    status?: string;
  };
}

export default function SearchClient() {
  const [showAdvanced, setShowAdvanced] = useState(false);
  const navigate = useNavigate();
  const toast = useRef<Toast | null>(null);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    policyNumber: "",
    vinNumber: "",
    dateOfBirth: "",
    effectiveDate: "",
    businessName: "",
    emailAddress: "",
    driversLicenseNumber: "",
  });

  const [searchResults, setSearchResults] = useState<ClientData[]>([]);
  const [isSearching, setIsSearching] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);
  const [selectedClientId, setSelectedClientId] = useState<string | null>(null);

  // Mock client data for demonstration
  // const mockClients: ClientData[] = [
  //   {
  //     id: "1",
  //     firstName: "John",
  //     lastName: "Smith",
  //     email: "john.smith@email.com",
  //     phone: "(555) 123-4567",
  //     address: "123 Main Street",
  //     city: "Anytown",
  //     state: "CA",
  //     zipCode: "12345",
  //     dateOfBirth: "1985-03-15",
  //     policyCount: 2,
  //     lastActivity: "2024-11-10",
  //     status: "Active",
  //     totalPremium: "$2,450",
  //     vinNumber: "1HGCM82633A004352",
  //   },
  //   {
  //     id: "2",
  //     firstName: "Jane",
  //     lastName: "Johnson",
  //     email: "jane.johnson@email.com",
  //     phone: "(555) 987-6543",
  //     address: "456 Oak Avenue",
  //     city: "Springfield",
  //     state: "CA",
  //     zipCode: "67890",
  //     dateOfBirth: "1990-07-22",
  //     policyCount: 1,
  //     lastActivity: "2024-11-05",
  //     status: "Active",
  //     totalPremium: "$1,250",
  //     vinNumber: "2T1BURHE5JC123456",
  //   },
  //   {
  //     id: "3",
  //     firstName: "Michael",
  //     lastName: "Brown",
  //     email: "michael.brown@email.com",
  //     phone: "(555) 456-7890",
  //     address: "789 Pine Road",
  //     city: "Riverside",
  //     state: "CA",
  //     zipCode: "54321",
  //     dateOfBirth: "1978-12-03",
  //     policyCount: 3,
  //     lastActivity: "2024-10-28",
  //     status: "Active",
  //     totalPremium: "$3,750",
  //     vinNumber: "3FAHP0HA6AR123789",
  //   },
  //   {
  //     id: "4",
  //     firstName: "Sarah",
  //     lastName: "Williams",
  //     email: "sarah.williams@email.com",
  //     phone: "(555) 234-5678",
  //     address: "321 Elm Street",
  //     city: "Los Angeles",
  //     state: "CA",
  //     zipCode: "90001",
  //     dateOfBirth: "1988-05-18",
  //     policyCount: 2,
  //     lastActivity: "2024-11-12",
  //     status: "Active",
  //     totalPremium: "$2,100",
  //     vinNumber: "1N4AL3AP9JC123654",
  //   },
  //   {
  //     id: "5",
  //     firstName: "David",
  //     lastName: "Martinez",
  //     email: "david.martinez@email.com",
  //     phone: "(555) 345-6789",
  //     address: "654 Maple Drive",
  //     city: "San Diego",
  //     state: "CA",
  //     zipCode: "92101",
  //     dateOfBirth: "1982-09-25",
  //     policyCount: 4,
  //     lastActivity: "2024-11-08",
  //     status: "Active",
  //     totalPremium: "$4,200",
  //     vinNumber: "JH4KA9650MC123321",
  //   },
  //   {
  //     id: "6",
  //     firstName: "Emily",
  //     lastName: "Davis",
  //     email: "emily.davis@email.com",
  //     phone: "(555) 567-8901",
  //     address: "987 Cedar Lane",
  //     city: "San Francisco",
  //     state: "CA",
  //     zipCode: "94102",
  //     dateOfBirth: "1995-11-30",
  //     policyCount: 1,
  //     lastActivity: "2024-11-15",
  //     status: "Active",
  //     totalPremium: "$1,800",
  //     vinNumber: "1FTFW1ET1EKF12345",
  //   },
  //   {
  //     id: "7",
  //     firstName: "Robert",
  //     lastName: "Anderson",
  //     email: "robert.anderson@email.com",
  //     phone: "(555) 678-9012",
  //     address: "147 Birch Avenue",
  //     city: "Sacramento",
  //     state: "CA",
  //     zipCode: "95814",
  //     dateOfBirth: "1975-04-12",
  //     policyCount: 3,
  //     lastActivity: "2024-10-20",
  //     status: "Active",
  //     totalPremium: "$3,300",
  //     vinNumber: "2C3KA53G76H123456",
  //   },
  //   {
  //     id: "8",
  //     firstName: "Lisa",
  //     lastName: "Taylor",
  //     email: "lisa.taylor@email.com",
  //     phone: "(555) 789-0123",
  //     address: "258 Willow Court",
  //     city: "Oakland",
  //     state: "CA",
  //     zipCode: "94601",
  //     dateOfBirth: "1992-08-07",
  //     policyCount: 2,
  //     lastActivity: "2024-11-01",
  //     status: "Active",
  //     totalPremium: "$2,650",
  //     vinNumber: "1G1JC5244R1234567",
  //   },
  //   {
  //     id: "9",
  //     firstName: "James",
  //     lastName: "Thomas",
  //     email: "james.thomas@email.com",
  //     phone: "(555) 890-1234",
  //     address: "369 Spruce Street",
  //     city: "Fresno",
  //     state: "CA",
  //     zipCode: "93721",
  //     dateOfBirth: "1987-02-28",
  //     policyCount: 1,
  //     lastActivity: "2024-11-14",
  //     status: "Active",
  //     totalPremium: "$1,450",
  //     vinNumber: "1FTNE24L44HA12345",
  //   },
  //   {
  //     id: "10",
  //     firstName: "Jennifer",
  //     lastName: "White",
  //     email: "jennifer.white@email.com",
  //     phone: "(555) 901-2345",
  //     address: "741 Poplar Drive",
  //     city: "Long Beach",
  //     state: "CA",
  //     zipCode: "90802",
  //     dateOfBirth: "1991-06-14",
  //     policyCount: 2,
  //     lastActivity: "2024-11-09",
  //     status: "Active",
  //     totalPremium: "$2,200",
  //     vinNumber: "1HGCM82633A123456",
  //   },
  // ];

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    const formatted =
      name === "phone" ? formatPhoneNumberDash(value) :
      name === "dateOfBirth" ? formatDateOfBirth(value) :
      value;
    setFormData((prev) => ({
      ...prev,
      [name]: formatted,
    }));
  };

  // const handleSearch = (e: React.FormEvent) => {
  //   e.preventDefault();
  //   setIsSearching(true);

  //   setTimeout(() => {
  //     const results = mockClients.filter((client) => {
  //       const firstNameMatch = !formData.firstName || client.firstName.toLowerCase().includes(formData.firstName.toLowerCase());
  //       const lastNameMatch = !formData.lastName || client.lastName.toLowerCase().includes(formData.lastName.toLowerCase());
  //       const phoneMatch = !formData.phone || client.phone.replace(/\D/g, "").includes(formData.phone.replace(/\D/g, ""));
  //       const policyNumberMatch = !formData.policyNumber || client.id === formData.policyNumber;
  //       const vinNumberMatch = !formData.vinNumber || (client.vinNumber && client.vinNumber.toLowerCase().includes(formData.vinNumber.toLowerCase()));
  //       const dobMatch = !formData.dateOfBirth || client.dateOfBirth === formData.dateOfBirth;
  //       const effectiveDateMatch = !formData.effectiveDate || client.lastActivity === formData.effectiveDate;
  //       const businessNameMatch = !formData.businessName; // Placeholder, add businessName to mockClients if needed
  //       const emailAddressMatch = !formData.emailAddress || client.email.toLowerCase().includes(formData.emailAddress.toLowerCase());
  //       const driversLicenseMatch = !formData.driversLicenseNumber; // Placeholder, add driversLicenseNumber to mockClients if needed
  //       return (
  //         firstNameMatch &&
  //         lastNameMatch &&
  //         phoneMatch &&
  //         policyNumberMatch &&
  //         vinNumberMatch &&
  //         dobMatch &&
  //         effectiveDateMatch &&
  //         businessNameMatch &&
  //         emailAddressMatch &&
  //         driversLicenseMatch
  //       );
  //     });

  //     setSearchResults(results);
  //     setIsSearching(false);
  //     setHasSearched(true);
  //   }, 1000);
  // };

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSearching(true);
    let data = JSON.stringify({
      businessName: formData.businessName,
      phoneNumber: formData.phone,
      firstName: formData.firstName,
      lastName: formData.lastName,
      dateOfBirth: formData.dateOfBirth,
      emailAddress: formData.emailAddress,
      drivingLicenseNumber: formData.driversLicenseNumber,
      policyNumber: formData.policyNumber,
      effectiveDate: formData.effectiveDate,
    });

    var config = {
      method: "post",
      url: `${process.env.REACT_APP_ACE_API_Url}/api/ace/client?nowCertsToken=${localStorage.getItem("NCToken")}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("igtoken")}`,
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then((response: any) => {
        const mappedResults = response.data.map((client: any) => ({
          ...client,
          id: client.databaseId || client.id || client.insuredDatabaseId || String(Math.random()),
        }));
        setSearchResults(mappedResults);
        setHasSearched(true);
        setIsSearching(false);
      })
      .catch((error: any) => {
        setIsSearching(false);
        if (error.response && error.response.status === 401) {
          localStorage.clear();
          navigate("/");
        } else {
          toast.current?.show({
            severity: "error",
            summary: "Error",
            detail:
              error.response && error.response.status
                ? `Error ${error.response.status}: ${error.response.data?.message || "An error occurred while searching the client!"}`
                : "Unknown error while searching the client!",
            life: 3000,
          });
        }
      });
  };
  const handleClientSelect = (client: ClientData) => {
    setSelectedClientId(client.id);
    // Scroll to top to show selected client
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleContinueWithClient = () => {
    const selectedClient = searchResults.find((c) => c.id === selectedClientId);
    if (selectedClient) {
      // Navigate to flow selection page with selected client data
      navigate("/select-quote-flow", { state: { selectedClient } });
    }
  };

  const handleClearSelection = () => {
    setSelectedClientId(null);
  };
  const handleNewQuoteClick = () => {
    localStorage.setItem("currentInsuredId", "null");
    navigate("/select-quote-flow");
  };
  const handleClearSearch = () => {
    setFormData({
      firstName: "",
      lastName: "",
      phone: "",
      policyNumber: "",
      vinNumber: "",
      dateOfBirth: "",
      effectiveDate: "",
      businessName: "",
      emailAddress: "",
      driversLicenseNumber: "",
    });
    setSearchResults([]);
    setHasSearched(false);
    setSelectedClientId(null);
  };

  const getQuoteStatusClass = (status?: string) => {
    if (!status) return "";
    const s = status.toLowerCase();
    if (s === "active") return "crc-status-active";
    if (s === "renewing") return "crc-status-renewing";
    if (s === "cancelled") return "crc-status-cancelled";
    if (s === "expired") return "crc-status-expired";
    if (s.includes("unbound")) return "crc-status-unbound";
    return "";
  };

  const getQuoteStatusLabel = (latestQuote?: ClientData["latestQuote"]) => {
    if (!latestQuote) return null;
    if (latestQuote.isQuote) return "Unbound Quote";
    return latestQuote.status || null;
  };

  return (
    <Layout currentPage="Search Client">
      <Toast ref={toast} />
      <div className="page-container">
        <div className="page-header">
          <div className="page-header-content">
            <div className="page-title-section">
              <h1>Search Client</h1>
              <span className="title-separator">|</span>
              <p>Find existing clients by entering their information</p>
            </div>
          </div>
        </div>
        {/* Selected Client Banner */}
        {selectedClientId &&
          (() => {
            const selectedClient = searchResults.find((c) => c.id === selectedClientId);
            if (!selectedClient) return null;
            return (
              <div className="selected-client-banner">
                <div className="selected-client-content">
                  <div className="selected-client-icon">
                    <svg viewBox="0 0 24 24" fill="none">
                      <path
                        d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <circle cx="12" cy="7" r="4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </div>
                  <div className="selected-client-info">
                    <div className="selected-client-label">Selected Client</div>
                    <div className="selected-client-name">
                      {selectedClient.firstName} {selectedClient.lastName}
                    </div>
                    <div className="selected-client-details">
                      <span>{selectedClient.eMail}</span>
                      <span className="separator">•</span>
                      <span>{selectedClient.phone}</span>
                    </div>
                  </div>
                </div>
                <div className="selected-client-actions" style={{ display: "flex", gap: "1rem" }}>
                  <button className="btn btn-primary" onClick={handleContinueWithClient}>
                    Continue with Client
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3.5" d="M9 5l7 7-7 7" stroke="currentColor" />
                    </svg>
                  </button>
                  <button className="btn btn-secondary" onClick={handleClearSelection}>
                    {/* <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg> */}
                    Clear Selection
                  </button>
                </div>
              </div>
            );
          })()}

        <div className="search-section">
          <form onSubmit={handleSearch} className="search-form">
            <div className="form-row mb-0">
              <div className="form-group">
                <label htmlFor="firstName">First Name</label>
                <input
                  type="text"
                  id="firstName"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleInputChange}
                  placeholder="First name"
                  className="form-input"
                />
              </div>
              <div className="form-group">
                <label htmlFor="lastName">Last Name</label>
                <input
                  type="text"
                  id="lastName"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleInputChange}
                  placeholder="Last name"
                  className="form-input"
                />
              </div>
              <div className="form-group">
                <label htmlFor="phone">Phone Number</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleInputChange}
                  placeholder="555-123-4567"
                  className="form-input"
                />
              </div>
            </div>
            <div style={{ width: "100%" }}>

              {showAdvanced && (
                <div
                  className="form-row "
                  style={{ marginTop: 0, display: "grid", gridTemplateColumns: "repeat(4, minmax(150px, 1fr))", gap: "1rem" }}
                >
                  <div className="form-group">
                    <label htmlFor="policyNumber">Policy Number</label>
                    <input
                      type="text"
                      id="policyNumber"
                      name="policyNumber"
                      value={formData.policyNumber}
                      onChange={handleInputChange}
                      placeholder="Policy number"
                      className="form-input"
                      style={{ width: "100%" }}
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="vinNumber">VIN Number</label>
                    <input
                      type="text"
                      id="vinNumber"
                      name="vinNumber"
                      value={formData.vinNumber}
                      onChange={handleInputChange}
                      placeholder="VIN number"
                      className="form-input"
                      style={{ width: "100%" }}
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="dateOfBirth">Date of Birth</label>
                    <input
                      type="text"
                      id="dateOfBirth"
                      name="dateOfBirth"
                      value={formData.dateOfBirth}
                      onChange={handleInputChange}
                      className="form-input"
                      placeholder="MM/DD/YYYY"
                      style={{ width: "100%" }}
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="effectiveDate">Effective Date</label>
                    <input
                      type="date"
                      id="effectiveDate"
                      name="effectiveDate"
                      value={formData.effectiveDate}
                      onChange={handleInputChange}
                      className="form-input"
                      style={{ width: "100%" }}
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="businessName">Business Name</label>
                    <input
                      type="text"
                      id="businessName"
                      name="businessName"
                      value={formData.businessName}
                      onChange={handleInputChange}
                      placeholder="Business name"
                      className="form-input"
                      style={{ width: "100%" }}
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="emailAddress">Email Address</label>
                    <input
                      type="email"
                      id="emailAddress"
                      name="emailAddress"
                      value={formData.emailAddress}
                      onChange={handleInputChange}
                      placeholder="Email address"
                      className="form-input"
                      style={{ width: "100%" }}
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="driversLicenseNumber">Driver's License Number</label>
                    <input
                      type="text"
                      id="driversLicenseNumber"
                      name="driversLicenseNumber"
                      value={formData.driversLicenseNumber}
                      onChange={handleInputChange}
                      placeholder="Driver's license number"
                      className="form-input"
                      style={{ width: "100%" }}
                    />
                  </div>
                </div>
              )}
              <button
                type="button"
                className="advanced-search-button"
                onClick={() => setShowAdvanced((prev) => !prev)}
                style={{
                  width: "100%",
                  margin: "1rem 0",
                  padding: "0.5rem 1rem",
                  border: "1px solid #ccc",
                  borderRadius: "6px",
                  backgroundColor: "#f5f5f5",
                  color: "#333",
                  fontWeight: 500,
                  fontSize: "0.95rem",
                  cursor: "pointer",
                }}
              >
                {showAdvanced ? "Hide Advanced Search" : "Show Advanced Search"}
              </button>
            </div>
            <div className="form-actions" style={{ display: "flex", gap: "1rem", alignItems: "center" }}>
              <button type="button" className="btn btn-primary" onClick={handleNewQuoteClick}>
                New Quote
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3.5" d="M9 5l7 7-7 7" stroke="currentColor" />
                </svg>
              </button>
              <button type="submit" className="btn btn-primary" disabled={isSearching}>
                {isSearching ? "Searching..." : "Search Client"}
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3.5" d="M9 5l7 7-7 7" stroke="currentColor" />
                </svg>
              </button>
              <button type="button" className="btn btn-secondary" onClick={handleClearSearch}>
                Clear
              </button>
            </div>
          </form>
        </div>

        {/* Search Results Section */}
        {hasSearched && (
          <div className="results-section">
            <div className="results-header">
              <h3>Search Results</h3>
              <span className="results-count">
                {searchResults.length} client{searchResults.length !== 1 ? "s" : ""} found
              </span>
            </div>

            {searchResults.length > 0 ? (
              <div className="client-card-grid">
                {searchResults.map((client) => {
                  const isSelected = selectedClientId === client.id;
                  const initials = `${client.firstName?.[0] || ""}${client.lastName?.[0] || ""}`.toUpperCase();
                  return (
                    <div
                      key={client.id}
                      className={`client-result-card ${isSelected ? "selected" : ""}`}
                      onClick={() => handleClientSelect(client)}
                    >
                      <div className="crc-header">
                        <span className="crc-name">{client.firstName} {client.lastName}</span>
                        <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                          {client?.latestQuote && (
                            <span className={`crc-quote-status ${getQuoteStatusClass(client.latestQuote.isQuote ? "unbound" : client.latestQuote.status)}`}>
                              {getQuoteStatusLabel(client.latestQuote)}
                            </span>
                          )}
                          {isSelected && <span className="crc-selected-badge">✓ Selected</span>}
                        </div>
                      </div>
                      <div className="crc-fields">
                        <div className="crc-field">
                          <svg width="12" height="12" viewBox="0 0 24 24" fill="none"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" stroke="currentColor" strokeWidth="2"/><polyline points="22,6 12,13 2,6" stroke="currentColor" strokeWidth="2"/></svg>
                          <span className="crc-field-label">Email:</span>
                          <span className="crc-field-value">{client.eMail || <span className="text-placeholder">—</span>}</span>
                        </div>
                        <div className="crc-field">
                          <svg width="12" height="12" viewBox="0 0 24 24" fill="none"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.128.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.572 2.81.7A2 2 0 0 1 22 16.92z" stroke="currentColor" strokeWidth="2"/></svg>
                          <span className="crc-field-label">Phone:</span>
                          <span className="crc-field-value">{client.phone || <span className="text-placeholder">—</span>}</span>
                        </div>
                        <div className="crc-field">
                          <svg width="12" height="12" viewBox="0 0 24 24" fill="none"><rect x="3" y="4" width="18" height="18" rx="2" ry="2" stroke="currentColor" strokeWidth="2"/><line x1="16" y1="2" x2="16" y2="6" stroke="currentColor" strokeWidth="2"/><line x1="8" y1="2" x2="8" y2="6" stroke="currentColor" strokeWidth="2"/><line x1="3" y1="10" x2="21" y2="10" stroke="currentColor" strokeWidth="2"/></svg>
                          <span className="crc-field-label">Eff. Date:</span>
                          <span className={`crc-field-value ${getQuoteStatusClass(client.latestQuote?.isQuote ? "unbound" : client.latestQuote?.status)}`}>
                            {client?.latestQuote?.effectiveDate ? new Date(client.latestQuote.effectiveDate).toLocaleDateString() : <span className="text-placeholder">—</span>}
                          </span>
                        </div>
                        <div className="crc-field">
                          <svg width="12" height="12" viewBox="0 0 24 24" fill="none"><path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>
                          <span className="crc-field-label">Policy #:</span>
                          <span className={`crc-field-value ${getQuoteStatusClass(client.latestQuote?.isQuote ? "unbound" : client.latestQuote?.status)}`}>
                            {client?.latestQuote?.number || <span className="text-placeholder">—</span>}
                          </span>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              <div className="no-results">
                <div className="no-results-icon">
                  <svg viewBox="0 0 24 24" fill="none">
                    <circle cx="11" cy="11" r="8" stroke="currentColor" strokeWidth="2" />
                    <path d="M21 21l-4.35-4.35" stroke="currentColor" strokeWidth="2" />
                  </svg>
                </div>
                <h4>No clients found</h4>
                <p>Try adjusting your search criteria or check the spelling.</p>
              </div>
            )}
            {/* Show the new quote button at the bottom only if no client is found */}
          </div>
        )}
      </div>

      {/* Floating Action Button - appears when client is selected */}

      {hasSearched && searchResults.length === 0 && (
        <div className="floating-action-bar">
          <div className="floating-actions" style={{ display: "flex", gap: "1rem", justifyContent: "flex-end", width: "100%" }}>
            <button className="btn btn-primary" onClick={handleNewQuoteClick}>
              Continue to New Quote
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3.5" d="M9 5l7 7-7 7" stroke="currentColor" />
              </svg>
            </button>
          </div>
        </div>
      )}

      {selectedClientId &&
        (() => {
          const selectedClient = searchResults.find((c) => c.id === selectedClientId);
          if (!selectedClient) return null;
          return (
            <div className="floating-action-bar">
              <div className="floating-client-info">
                <svg viewBox="0 0 24 24" fill="none">
                  <path
                    d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <circle cx="12" cy="7" r="4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                <span>
                  <strong>
                    {selectedClient.firstName} {selectedClient.lastName}
                  </strong>{" "}
                  selected
                </span>
              </div>
              <div className="floating-actions" style={{ display: "flex", gap: "1rem" }}>
                <button className="btn btn-primary" onClick={handleContinueWithClient}>
                  Continue with Client
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3.5" d="M9 5l7 7-7 7" stroke="currentColor" />
                  </svg>
                </button>
                <button className="btn btn-secondary" onClick={handleClearSelection} title="Clear selection">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </button>
              </div>
            </div>
          );
        })()}
    </Layout>
  );
}